import React from 'react';
import { Folder, Calendar, Code } from 'lucide-react';
import { formatDate, truncateText } from '../../utils/helpers';
import Button from '../UI/Button';

const ProjectCard = ({ project, onOpen }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center">
          <Folder className="h-8 w-8 text-blue-600 mr-3" />
          <div>
            <h3 className="text-lg font-semibold text-gray-900">{project.name}</h3>
            <p className="text-sm text-gray-600">{project.framework}</p>
          </div>
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onOpen(project)}
        >
          Open
        </Button>
      </div>

      {project.description && (
        <p className="text-gray-600 text-sm mb-4">
          {truncateText(project.description, 120)}
        </p>
      )}

      <div className="flex items-center justify-between text-sm text-gray-500">
        <div className="flex items-center">
          <Calendar className="h-4 w-4 mr-1" />
          <span>{formatDate(project.updated_at)}</span>
        </div>
        <div className="flex items-center">
          <Code className="h-4 w-4 mr-1" />
          <span>{project.versions_count} versions</span>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;